import { BKJCenteredDialog } from 'components/BKJCenteredDialog';
import { DeleteCustomerDialogProps } from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/DeleteCustomerDialog/DeleteCustomerDialog.types';
import {
  DeleteCustomerDialogFormProvider,
  useDeleteCustomerDialogFormContext,
} from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/DeleteCustomerDialog/DeleteCustomerDialog.form.context';
import { FC } from 'react';
import { useTranslation } from 'hooks/useTranslation';

const DeleteCustomerDialogView: FC<DeleteCustomerDialogProps> = ({
  isDeleteCustomerConfirmationOpen,
  setIsDeleteCustomerConfirmationOpen,
}) => {
  const { t } = useTranslation();
  const { handleDeleteCustomer } = useDeleteCustomerDialogFormContext();

  return (
    <BKJCenteredDialog
      isOpen={isDeleteCustomerConfirmationOpen}
      variant="Default"
      title={t('location_settings:DELETE_CUSTOMER')}
      text={t('location_settings:DELETE_CUSTOMER_WARNING')}
      cancelLabel={t('auth:CANCEL')}
      actionLabel={t('shift_modal:CONTINUE')}
      onAction={() => {
        setIsDeleteCustomerConfirmationOpen(false);
        return handleDeleteCustomer();
      }}
      onCancel={() => setIsDeleteCustomerConfirmationOpen(false)}
      onClose={() => setIsDeleteCustomerConfirmationOpen(false)}
    />
  );
};

export const DeleteCustomerDialog: FC<DeleteCustomerDialogProps> = (props) => {
  return (
    <DeleteCustomerDialogFormProvider {...props}>
      <DeleteCustomerDialogView {...props} />
    </DeleteCustomerDialogFormProvider>
  );
};
